var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_material-remove-red-eye",
    "data-name": "Icon material-remove-red-eye",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 10.786,
    viewBox: "0 0 16 10.786",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-eye",
    "data-name": "Icon ionic-md-eye",
    d: "M10.25,7.383a8.6,8.6,0,0,0-8,5.393,8.63,8.63,0,0,0,16,0A8.6,8.6,0,0,0,10.25,7.383Zm0,8.989a3.6,3.6,0,1,1,3.636-3.6A3.626,3.626,0,0,1,10.25,16.372Zm0-5.754a2.157,2.157,0,1,0,2.182,2.157A2.177,2.177,0,0,0,10.25,10.619Z",
    transform: "translate(-2.25 -7.383)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOn);
export default __webpack_public_path__ + "static/media/eye-on.7061017501031f5fb398ad70fed1d341.svg";
export { ForwardRef as ReactComponent };